import React from "react";
import ItemsPage from "./ItemsPage/ItemPage";
import { Switch, Route, Redirect } from "react-router-dom";
import ItemsDirectory from "./ItemsDirectory/ItemsDirectory";

const Items = (props) => {
  return (
    <Switch>
      <Route path={`/lol/items/:itemName`} render={(props) => <ItemsPage {...props} />} />
      <Route path="/lol/items" render={(props) => <ItemsDirectory {...props} />} />
    </Switch>
  );
};

export default Items;
